module.exports = __webpack_public_path__ + "static/media/00_tank_game_card.27629359.png";